module.exports = {
  siteTitle: "Essential JS 2", // Site title.
  siteTitleAlt: "Essential JS 2 Docs", // Alternative site title for SEO.
  siteLogo: "/logos/syncfusion-logo.svg", // Logo used for SEO and manifest.
  siteUrl: "https://ej2.syncfusion.com", // Domain of your website without pathPrefix.
  pathPrefix: "/development/react/documentation", // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription: "Essential JS 2 Documentation", // Website description used for RSS feeds/meta description tag.  siteFBAppID: "1825356251115265", // FB Application ID for using app insights
  googleAnalyticsID: "UA-233131-15", // GA tracking ID.
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  userLinks: [
    {
      label: "GitHub",
      url: "https://github.com/ericwindmill",
      iconClassName: "fa fa-github"
    }
  ],
  copyright: "Copyright © 2001-" + new Date().getFullYear()+" Syncfusion Inc.", // Copyright string for the footer of the website and RSS feed.
  themeColor: "#2973b7", // Used for setting manifest and progress theme colors.
  backgroundColor: "#e0e0e0", // Used for setting manifest background color.
  version: "19.2.49",
  nugetVersion: "19.2.0.49",
  isApi: false
};
